import { Box } from "@mui/material";
import { DotLegalEmptyState } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { isNullOrWhitespace } from "../../stringOperations.ts";
import { filterPopoverSubMenuWidth } from "./FilterPopoverSubMenu.tsx";

export interface FilterPopoverSubMenuEmptyStateProps {
    emptyText?: string;
}

function FilterPopoverSubMenuEmptyState(props: FilterPopoverSubMenuEmptyStateProps) {
    const { translateString } = useTranslation();
    return (
        <Box
            sx={{
                width: filterPopoverSubMenuWidth,
                "& > div > div": {
                    height: "100px", // or any height you want
                },
                "& span": {
                    marginTop: "18px",
                },
            }}
        >
            <DotLegalEmptyState text={isNullOrWhitespace(props.emptyText) ? translateString("noData") : props.emptyText} />
        </Box>
    );
}

export default FilterPopoverSubMenuEmptyState;
